module.exports = __webpack_public_path__ + "static/img/4areaA_5.d3c09df.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/4areaA_5.png
// module id = 1031
// module chunks = 1